/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.masterTools").
controller("DxMasterToolsUserViewController", function MasterToolsUserViewController(
	$rootScope,
	$routeParams,
	$scope,
	$window,
	$filter,

	NodeRepository,
	Node,
	role,
	student,
	user,
	dxApi,
	DxUser,

	dxDialog
) {
	"use strict";

	$scope.organizations = {};
	$scope.user = new DxUser();
	$scope.dxApi = dxApi;
	$scope.roleInvitations = [];


	$scope.userId = parseInt($routeParams.id, 10);
	var deleteInProgress = false;

	user.get($scope.userId).then(function onSuccess(u) {
		$scope.user = new DxUser(u);
	});

	dxApi.v1.users.invites.get($scope.userId).then(function onSuccess(data) {
		$scope.roleInvitations = data ? data : [];

		for (var i = 0; i < $scope.roleInvitations.length; i++) {
			$scope.lazyLoadOrg($scope.roleInvitations[i].nodeId);
			$scope.roleInvitations[i].sentAt = $filter("date")(new Date($scope.roleInvitations[i].sentAt), "yyyy-MM-dd HH:mm:ss");
		}
	}, function onError(err) {
		$window.console.log("Could not load invites: ", err);
	});

	student.query({userId: $scope.userId}).then(function onSuccess(response) {
		$scope.students = response.data;
		for (var i = 0; i < $scope.students.length; i++) {
			var s = $scope.students[i];
			$scope.lazyLoadOrg(s.organizationId);

			if (!s.examIds) {
				s.examIds = [];
			}
		}
	});

	role.query({userId: $scope.userId}).then(function onSuccess(response) {
		$scope.roles = response.data;
		for (var i = 0; i < $scope.roles.length; i++) {
			var r = $scope.roles[i];
			$scope.lazyLoadOrg(r.organizationId);
		}
	});


	$scope.saveUser = function saveUser() {
		$scope.user.update().then(function onSuccess(response) {
			if (response.faults) {
				$scope.saveUserMessage = response.msgs[0];
			} else {
				$scope.user = new DxUser(response);
				$scope.saveUserMessage = "Saved!";
			}
		});
	};

	$scope.lazyLoadOrg = function lazyLoadOrg(orgId) {
		if (!$scope.organizations[orgId]) {
			$scope.organizations[orgId] = {title: "Loading..."};

			NodeRepository.load(orgId).then(function onSuccess(organization) {
				$scope.organizations[orgId] = new Node(organization);
			});
		}
	};

	$scope.pricePlan = function pricePlan(orgId) {
		if ($scope.organizations[orgId].freemium) {
			return "Freemium";
		}
		return "Paying";
	};

	$scope.deleteUser = function deleteUser() {
		dxDialog.confirm({
			title: "Delete user",
			body: "Are you sure you want to delete this user",
			acceptText: "Delete",
			acceptCallback: runDelete,
			rejectText: "Cancel",
		});

		function runDelete() {
			if (!deleteInProgress) {
				deleteInProgress = true;
				$scope.user.deleteUser($scope.user.id).then(success, failed);
			}
		}
		function failed(response) {
			deleteInProgress = false;
			dxDialog.alert({
				title: "User couldn't be deleted",
				body: "The user was not deleted, The error is: " + response.data.message,
				acceptText: "Ok",
			});
		}
		function success(response) {
			deleteInProgress = false;
			var scope = $rootScope.$new();
			scope.job = response;
			scope.close = function close() {
				dxDialog.closeMostRecent();
			};
			dxDialog.alert({
				templateUrl: "tmpl/mastertools/user-deletion-success-popup.html",
				$scope: scope,
			});
		}
	};

	$scope.exportPII = function exportPII() {
		dxDialog.alert({
			title: "Exporting PII for user",
			body: "" +
			"File will be downloaded to your computer. <br>" +
			"You will need to send an email to SendGrid and Intercom to extract the PII information from them. <br>" +
			"Email: privacy@sendgrid.com, compliance@intercom.com <br>" +
			"Website: https://docs.intercom.com/pricing-privacy-and-terms/data-protection/how-can-i-export-my-intercom-data-for-gdpr",
			acceptText: "Ok",
		});
	};

	$scope.forceAccept = function forceAcceptInvite(inviteId) {
		dxApi.v1.invites.forceAccept.post(inviteId).then(function onSuccess() {
			var newList = [];

			for (var i = 0; i < $scope.roleInvitations.length; i++) {
				if ($scope.roleInvitations[i].id !== inviteId) {
					newList.push($scope.roleInvitations[i]);
				}
			}

			$scope.roleInvitations = newList;
		}, function onError(error) {
			$window.console.log("error accepting invite: ", error);
		});
	};
});
